import React from 'react';
import { Check, Home, Edit } from 'lucide-react';
import type { FormSubmissionResult } from '../../../types/publicForm.types';

interface FormConfirmationProps {
  message: string;
  confirmationData?: FormSubmissionResult;
  primaryColor: string;
  onBackToHome: () => void;
  onStartOver: () => void;
  onEditSubmission?: () => void;
}

export const FormConfirmation: React.FC<FormConfirmationProps> = ({
  message,
  confirmationData,
  primaryColor,
  onBackToHome,
  onStartOver,
  onEditSubmission,
}) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white/95 backdrop-blur-sm rounded-lg shadow-lg p-8 text-center">
          <div
            className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-6"
            style={{ backgroundColor: `${primaryColor}20` }}
          >
            <Check className="h-8 w-8" style={{ color: primaryColor }} />
          </div>

          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Form Submitted Successfully!
          </h2>

          {confirmationData?.confirmationNumber && (
            <div className="mb-4">
              <p className="text-sm text-gray-600 mb-1">Confirmation Number</p>
              <p className="text-2xl font-bold" style={{ color: primaryColor }}>
                {confirmationData.confirmationNumber}
              </p>
            </div>
          )}

          <div
            className="prose prose-sm max-w-none text-gray-700 mx-auto mb-8"
            dangerouslySetInnerHTML={{ __html: confirmationData?.confirmationMessage || message }}
          />

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={onStartOver}
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Submit Another Response
            </button>
            {confirmationData?.editUrl && onEditSubmission && (
              <button
                onClick={onEditSubmission}
                className="px-6 py-3 bg-white border-2 text-gray-700 rounded-lg font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 inline-flex items-center"
                style={{
                  borderColor: primaryColor,
                  color: primaryColor
                }}
              >
                <Edit className="h-4 w-4 mr-2" />
                Edit Submission
              </button>
            )}
            <button
              onClick={onBackToHome}
              className="px-6 py-3 text-white rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 shadow-sm inline-flex items-center"
              style={{
                backgroundColor: primaryColor,
                '--tw-ring-color': primaryColor
              } as React.CSSProperties}
            >
              <Home className="h-4 w-4 mr-2" />
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};